import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { BulletinType } from './bulletin-type';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class BulletinTypeService {

    private api_url = `${environment.ApiUrl}/bulletinType`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<BulletinType[]>(this.api_url);
    }

    save(bulletinType: BulletinType) {
        return this.http.post<BulletinType>(this.api_url, bulletinType, httpOptions);
    }

    update(bulletinType: BulletinType) {
        return this.http.put<BulletinType>(this.api_url, bulletinType, httpOptions);
    }

    delete(bulletinType: BulletinType) {
        const url = `${this.api_url}/${bulletinType.id}`;
        return this.http.delete(url, httpOptions);
    }
}